// extracted by mini-css-extract-plugin
export default {"modalContent":"ProjectCreationExitModal_modalContent_aBAMR","btnExit":"ProjectCreationExitModal_btnExit_HIpc3","exitColor":"ProjectCreationExitModal_exitColor_sYaqR"};